import React from 'react';
import { TextField } from '@mui/material';
import InputMask from 'react-input-mask';
import { formatarDataParaBR, formatarDataParaISO } from '../../../../../Utils/FormataData';

interface Props {
  value: string; // deve vir em formato ISO (yyyy-mm-dd)
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  tipoPessoa: 'FISICA' | 'JURIDICA'; // nova prop só para a view
}

const InputMaskCustom = React.forwardRef<HTMLInputElement, any>((props, ref) => (
  <InputMask {...props} mask="99/99/9999" maskChar={null}>
    {(inputProps: any) => <input {...inputProps} ref={ref} />}
  </InputMask>
));

export const CampoData: React.FC<Props> = ({ value, onChange, error, tipoPessoa }) => {
  const handleMaskedChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const dataBR = e.target.value;

    const evento = {
      ...e,
      target: {
        ...e.target,
        name: 'dataNascimento', // mantém igual
        value:
          dataBR.length === 10 && /^\d{2}\/\d{2}\/\d{4}$/.test(dataBR)
            ? formatarDataParaISO(dataBR)
            : dataBR,
      },
    };

    onChange(evento as React.ChangeEvent<HTMLInputElement>);
  };

  return (
    <TextField
      fullWidth
      label={tipoPessoa === 'FISICA' ? 'Data de Nascimento' : 'Data de Fundação'} // só troca o rótulo
      name="dataNascimento"
      value={formatarDataParaBR(value)}
      onChange={handleMaskedChange}
      margin="normal"
      error={!!error}
      helperText={error}
      InputLabelProps={{ shrink: true }}
      InputProps={{
        inputComponent: InputMaskCustom as any,
      }}
    />
  );
};
